import $ from 'jquery';
import { Functions } from '../../../helpers';
import { Component } from '../../../component';

export class Tabs extends Component {
    /**
     * Setup
     */
    setup() {
		$( 'body' )
			.on( 'init', '.js-c-tabs', function() {
				$( '.js-c-tab' ).hide();

				var $tabs = $( this ).find( '.js-c-tabs__items' ).first();

				$tabs.find( 'li:first a' ).click();
			} )
			.on( 'click', '.js-c-tabs li a', function( e ) {
				e.preventDefault();

				var $tab          = $( this );
				var $tabs_wrapper = $tab.closest( '.js-c-tabs' );
				var $tabs         = $tabs_wrapper.find( '.js-c-tabs__items' );

				$tabs.find( 'li' ).removeClass( 'active' );
				$tabs_wrapper.find( '.js-c-tab' ).hide();

				$tab.closest( 'li' ).addClass( 'active' );
				$tabs_wrapper.find( $tab.attr( 'href' ) ).show();
			} );

		// Init Tabs and Star Ratings
		$( '.js-c-tabs' ).trigger( 'init' );
    }
}
